<template>
  <el-container class="layout">
    <el-aside width="210px" class="layout-aside">
      <div class="logo">AI 陪聊后台</div>
      <el-menu
        :default-active="activePath"
        router
        class="side-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409eff"
      >
        <el-menu-item index="/overview">数据概览</el-menu-item>
        <el-menu-item index="/users">用户管理</el-menu-item>
        <el-menu-item index="/user-360">用户360</el-menu-item>
        <el-menu-item index="/reports-tickets">报告工单</el-menu-item>
        <el-menu-item index="/orders-compensations">订单补偿</el-menu-item>
        <el-menu-item index="/audit-logs">审计日志</el-menu-item>
        <el-menu-item index="/fortune-ops">算命运营</el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="layout-header">
        <div class="header-title">{{ title }}</div>
        <div class="header-right">
          <el-tag>管理员</el-tag>
          <el-button link type="danger" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { clearToken } from '../utils/auth'

const route = useRoute()
const router = useRouter()

const titleMap = {
  '/overview': '数据概览',
  '/users': '用户管理',
  '/user-360': '用户360',
  '/reports-tickets': '报告工单',
  '/orders-compensations': '订单补偿',
  '/audit-logs': '审计日志',
  '/fortune-ops': '算命运营'
}

const activePath = computed(() => route.path)
const title = computed(() => titleMap[route.path] || '后台管理')

function logout() {
  clearToken()
  router.replace('/login')
}
</script>

<style scoped>
.layout {
  min-height: 100vh;
}

.layout-aside {
  background: #304156;
}

.logo {
  height: 56px;
  line-height: 56px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.side-menu {
  border-right: none;
}

.layout-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #dcdfe6;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.layout-main {
  background: #f0f2f5;
  padding: 16px;
}
</style>
